const c = {
  name: "Puzzle",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v34c0,1.7,1.3,3,3,3h34c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M2,3c0-0.5,0.5-1,1-1h16v3
			c-0.2,0-0.3,0-0.5,0C16,5,14,7,14,9.5c0,2.5,2,4.5,4.5,4.5c0.2,0,0.3,0,0.5,0v5h-7l0.7,1.5c0.2,0.3,0.2,0.7,0.2,1
			c0,1.4-1.1,2.5-2.5,2.5C9.1,24,8,22.9,8,21.5c0-0.4,0.1-0.7,0.2-1L9,19H2V3z M19,21v7l1.5-0.7c0.3-0.2,0.7-0.2,1-0.2
			c1.4,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5c-0.4,0-0.7-0.1-1-0.2L19,31v7H3c-0.5,0-1-0.5-1-1V21h4c0,0.2,0,0.3,0,0.5
			C6,24,8,26,10.5,26c2.5,0,4.5-2,4.5-4.5c0-0.2,0-0.3,0-0.5H19z M21,2h16c0.5,0,1,0.5,1,1v16h-4c0-0.2,0-0.3,0-0.5
			c0-2.5-2-4.5-4.5-4.5C27,14,25,16,25,18.5c0,0.2,0,0.3,0,0.5h-4v-8l-1.5,0.7c-0.3,0.2-0.7,0.2-1,0.2c-1.4,0-2.5-1.1-2.5-2.5
			C16,8.1,17.1,7,18.5,7c0.4,0,0.7,0.1,1,0.2L21,8V2z M38,21v16c0,0.5-0.5,1-1,1H21v-4c0.2,0,0.3,0,0.5,0c2.5,0,4.5-2,4.5-4.5
			S24,25,21.5,25c-0.2,0-0.3,0-0.5,0v-4h7l-0.7-1.5c-0.2-0.3-0.2-0.7-0.2-1c0-1.4,1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5
			c0,0.4-0.1,0.7-0.2,1L31,21H38z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Puzzle
};
